
/* injects from baggage-loader */

'use strict';

import DroppableBoxTpl from './droppable-box.html';
import DroppableBoxController from '../droppable-box/droppable-box.controller';

export default class DroppableBoxComponent {
    constructor() {
        this.templateUrl = DroppableBoxTpl;
        this.controller = DroppableBoxController;
        this.bindings = {
            type: "@",
            data: "=",
            endGame: "&"
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/droppable-box/droppable-box.component.js